import React from "react";
import "../App.css";

import i18next from "../i18n";
import { Helmet } from "react-helmet-async";
import klp_logo from "../images/customers/klp.svg";
import dnb_logo from "../images/customers/dnb.svg";
import gjensidige_logo from "../images/customers/gjensidige.svg";
import circlek_logo from "../images/customers/circle_k.svg";
import nav_logo from "../images/customers/nav.svg";
import nav_logo_dark from "../images/customers/nav_dark.svg";
import LogoCarousel from "../components/LogoCarousel";
import Button from "../components/Button";
import FeatureCards from "../components/FeatureCards";
import financeArt from "../images/illustrations/customers/feature-finance.svg";
import publicArt from "../images/illustrations/customers/feature-public.svg";
import enterpriseArt from "../images/illustrations/customers/feature-enterprise.svg";
import { useNavigate } from "react-router-dom";

const company_logos = [
  {
    name: "KLP",
    img: klp_logo,
  },
  {
    name: "DNB",
    img: dnb_logo,
  },
  {
    name: "Gjensidige",
    img: gjensidige_logo,
  },
  {
    name: "Circle K",
    img: circlek_logo,
  },
  {
    name: "Nav",
    img: nav_logo,
  },
];

function Customers() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen ">
      <Helmet>
        <title>{i18next.t("pages.customers.title")}</title>
        <meta name="description" content={i18next.t("pages.customers.title")} />
        <link rel="canonical" href="https://xperconsulting.no/kunder" />
      </Helmet>
      <div className="bg-white">
        <div className="container max-w-xl pt-36 mb-12 justify-start items-start text-main-dark">
          <div className="w-full md:w-3/5 text-left text-xl">
            <h1 className="text-5xl font-bold text-main-dark mb-6">
              {i18next.t("pages.customers.title")}
            </h1>
            <p >
             <b> {i18next.t("pages.customers.intro.lead")} </b>
              {i18next.t("pages.customers.intro.description")}
            </p>
            <p className="text-secondary ">
              {i18next.t("pages.customers.description")}
            </p>
            <p className="text-secondary ">
              {i18next.t("pages.customers.longTerm")}
            </p>
            <p className="text-secondary ">
              {i18next.t("pages.customers.trust")}
            </p>
          </div>
        </div>
      </div>

      <FeatureCards
        items={[
          // To restore an original icon, uncomment its row and comment out the illustration row below it.
          // { icon: "finance", key: "pages.customers.featureCards.finance", tone: "warm", list: true },
          { illustration: financeArt, key: "pages.customers.featureCards.finance", tone: "warm", list: true },
          // { icon: "public", key: "pages.customers.featureCards.public", tone: "warm", list: true },
          { illustration: publicArt, key: "pages.customers.featureCards.public", tone: "warm", list: true },
          // { icon: "enterprise", key: "pages.customers.featureCards.enterprise", tone: "warm", list: true },
          { illustration: enterpriseArt, key: "pages.customers.featureCards.enterprise", tone: "warm", list: true },
        ]}
      />
      <div className="bg-white ">
        <div className="container max-w-2xl flex-col my-24 justify-center">
          <h2 className="text-4xl font-bold text-main-dark mb-12">
            {i18next.t("pages.customers.testimonials.title")}
          </h2>
          <div className="max-w-sm flex flex-col justify-center text-main-dark bg-gray rounded-3xl p-12 text-left mr-auto mb-12">
            <p className="text-xl ">
              "{i18next.t("pages.customers.testimonials.nav.quote")}"
            </p>
            <img
              className="h-16 ml-auto"
              alt={i18next.t("pages.customers.testimonials.nav.logoAlt")}
              src={nav_logo_dark}
            />
          </div>
          <div className="max-w-sm flex flex-col justify-center text-white bg-secondary rounded-3xl p-12 text-left ml-auto">
            <p className="text-xl ">
              "{i18next.t("pages.customers.testimonials.gjensidige.quote")}"
            </p>
            <img
              className="h-12 ml-auto"
              alt={i18next.t("pages.customers.testimonials.gjensidige.logoAlt")}
              src={gjensidige_logo}
            />
          </div>
        </div>
      </div>
      <div className="bg-main py-16 px-4">
        <div className="container flex flex-col p-0">
          <LogoCarousel logos={company_logos} className="mt-12" />
        </div>
      </div>
      {/* <div className="bg-white ">
        <div className="container max-w-2xl flex-row my-24 pb-24 justify-center">
          <img
            src={history_image}
            alt="join us"
            className="w-2/5 rounded-3xl object-cover"
          />
          <div className=" w-1/2 h-96 flex justify-center items-center text-main-dark bg-gray rounded-3xl p-12 text-left mt-24 -mb-24 -ml-24 ">
            <div className="flex flex-col gap-4">
              <h3 className="text-4xl font-bold mb-0">
                Derfor velger kundene oss
              </h3>
              <ul className="list-disc list-inside text-lg">
                <li>+20 års erfaring innen CCM</li>
                <li>Spisskompetanse på universell utforming av dokumenter</li>
                <li>Effektive, skalerbare løsninger</li>
                <li>Integreres med dine systemer</li>
              </ul>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container max-w-2xl  gap-4 justify-center items-center text-main-dark py-36 flex-wrap md:flex-nowrap">
        <p className="text-xl mb-0">
          {i18next.t("pages.customers.cta.question")}
        </p>{" "}
        <Button
          variant="solid"
          color="mainDark"
          onClick={() => {
            navigate("/skjema/kontakt-oss");
          }}
        >
          {i18next.t("pages.customers.cta.button")}
        </Button>
      </div>
    </div>
  );
}

export default Customers;
